import { isNativeMobileApp } from './googleAuth.js';

// Light haptic tap for primary button presses inside the native shell —
// a no-op on web, where the Haptics plugin has nothing to bridge to.
export const triggerHaptic = async (style = 'Light') => {
    if (!isNativeMobileApp()) return;

    try {
        const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
        await Haptics.impact({ style: ImpactStyle[style] || ImpactStyle.Light });
    } catch {
        // Best-effort only — never let missing haptics support break a tap.
    }
};
